import { render, staticRenderFns } from "./SwPanel.vue?vue&type=template&id=1bc4dd43"
import script from "./SwPanel.vue?vue&type=script&lang=js"
export * from "./SwPanel.vue?vue&type=script&lang=js"
import style0 from "./SwPanel.vue?vue&type=style&index=0&id=1bc4dd43&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports